import axios from "axios"
import { isBrowser } from "./util"
import { ENDPOINTS } from "./endpoints"

export const getEmailPreferences = (subscriberKey) => {
    return new Promise(function(resolve, reject) {
        if(!isBrowser()){
            reject("Do not do this from Node!")
        }else{
            axios.get(
                `${ENDPOINTS.profileGet}?SubscriberKey=${subscriberKey}`
            ).then((result) => {
                resolve(result)
            }).catch((err)=>{
                reject(err)
            })
        }
    })
}